import React, { Component, createRef } from 'react'
import { Tab, Tabs } from "react-bootstrap";
import NeedHelp from '../Elements/NeedHelp';
import InputField from '../Elements/InputField';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import CheckBoxField from '../Elements/CheckboxField';
import AccountSelect from './components/AccountSelect';
import { GET_FLITER_ID, getInitialRoute, showAddAccountAlertNew, isAppleSafari, TOAST_ERROR } from '../../../../../../utils';
import { connect } from 'react-redux';
import { MediaBaseUrl } from '../../../../../../actions/api';
import { addUserAccount } from '../../../../../Authorization/SocialAuth/connectSocialAcc';
import { createFeedAction, getConnectedAccount } from '../../../../../../actions/addFeedActions';
import Select from 'react-select';
import { TIKTOK_HASHTAG_ID_URL } from '../../../../../../actions/accountsActions';
import $ from 'jquery';
import InfoSection from '../Elements/InfoSection';

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class Tiktokfeed extends Component {

    state = {
        postUrl: "",
        manuallyApprove: 0,
        filterType: 'Hashtag',
        filterId: 72,
        error: false,
        connetedAccount: null,
        connetedPrAccount: null,
        loading: false,
        hashtag: "",
        handle: "",
        hashtagError: false,
        handleError: false,
        authRequired: 0,
        countries: [],
        category: [],
        hashtagSuggestion: [],
        selectedCountry: { "label": "United States", "value": "US" },
        selectedCategory: { "label": "all", "value": "ALL" },
        selectdeHastag: null
    }

    selectRef = createRef();

    componentDidMount() {
        this.getCountries();
        this.getCategory();
        this.setState({ authRequired: this.props.feedInfo[0].authRequire })
        this.props.onFilterNameChange(this.state.filterType)
        channel.addEventListener("message", this.readAuthenticationCode);
        $('#tiktok_hashtag').on('blur', this.onBlurHandler);
    }


    getCountries = () => {
        fetch(`${MediaBaseUrl}countries.json`)
            .then(res => res.json())
            .then(data =>
                this.setState({ countries: data.map(({ value, label }) => ({ value, label })) })
            )
            .catch(err => console.error("Error loading country data:", err));
    }

    getCategory = () => {
        fetch(`${MediaBaseUrl}tiktok_hashtag.json`)
            .then(res => res.json())
            .then(data =>// console.log(data,'datadatadata')
                this.setState({ category: data })
            )
            .catch(err => console.error("Error loading country data:", err));
    };

    onPostUrlChange = (value) => this.setState({ postUrl: value, error: false });
    onManuallyApproveChange = (value) => this.setState({ manuallyApprove: value });
    onConnectedAccountChange = (value) => this.setState({ connetedAccount: value || 0 });
    onConnectedPrAccountChange = (value) => this.setState({ connetedPrAccount: value || 0 });
    onBlurHandler = (e) => setTimeout(() => this.setState({ hashtagSuggestion: [] }), 200);

    onTextChange = (e) => {
        const { selectedCountry, selectedCategory, connetedPrAccount, hashtagSuggestion, filterId } = this.state
        this.setState({ [e.target.name]: e.target.value, hashtagError: false, handleError: false });

        if (!hashtagSuggestion.length && filterId == 72 && connetedPrAccount) {

            const { value: category } = selectedCategory || {};
            const { value: country } = selectedCountry || {};
            const input = e.target.value;

            if (input && category && country) {
                const data = {
                    category,
                    country,
                    "accountId": connetedPrAccount,
                    "networkId": "27"
                }
                TIKTOK_HASHTAG_ID_URL(data).then(({ data: { response, responseCode } }) => {
                    if (responseCode == 200) {
                        this.setState({ hashtagSuggestion: response });
                    }
                }).catch(err => console.error("Error loading country data:", err));
            } else {
                this.onBlurHandler()
            }
        }
    }

    onSubmit = () => {
        const { filterId, hashtag, connetedAccount, connetedPrAccount } = this.state;
        const { personalAccount, isLimitExceed } = this.props;


        if (![70].includes(filterId) && isLimitExceed) {
            TOAST_ERROR("Please Upgrade your plan to add more feeds")
            return
        }

        if ([70, 71].includes(filterId)) {
            this.onAddFeed(null);
        } else if ([72].includes(filterId)) {
            const shouldAdd = !connetedPrAccount && personalAccount?.length;
            if ((!hashtag || hashtag == "") && filterId == 72) this.setState({ hashtagError: true });
            else shouldAdd ? this.onAddAccount(27) : this.onAddFeed(connetedPrAccount, 27)
        } else {
            !connetedAccount ? this.onAddAccount(28) : this.onAddFeed(null)
        }
    }

    onAddAccount = (id, isBussiness = "") => showAddAccountAlertNew({ id: id, name: 'tiktok' }, "addFeed", false, isBussiness);

    onAddConnection(accountId, networkId) {
        this.props.FETCH_CONNECTED_ACCOUNTS(networkId)
        this.setState({ hashtag: '' })
        if (networkId == 28) this.onAddFeed(accountId)
    }

    onAddFeed = (accountId, networkId = 28) => {
        const { manuallyApprove, postUrl, hashtag, handle, filterId, connetedAccount, selectdeHastag, selectedCountry, selectedCategory } = this.state
        const { navigation, hideAddfeed, wallId } = this.props
        if ((!postUrl || postUrl == "") && filterId == 70) {
            this.setState({ error: true });
        } else if ((!hashtag || hashtag == "") && filterId == 72) {
            this.setState({ hashtagError: true });
        } else if ((!handle || handle == "") && filterId == 71) {
            this.setState({ handleError: true });
        } else {
            var obj = {
                wallId: wallId,
                networkId: networkId,
                filter: filterId,
                moderation: Number(manuallyApprove),
                feedText: '',
                accountId: accountId ? accountId : connetedAccount,
            }

            if (networkId == 27 && filterId == 72) {
                obj['value1'] = selectdeHastag?.hashtagName == hashtag ? selectdeHastag?.hashtagId : null;
                obj['value2'] = selectdeHastag?.hashtagName == hashtag ? selectedCountry?.value : null;
                obj['value3'] = selectdeHastag?.hashtagName == hashtag ? selectedCategory?.value : null;
            }

            if (filterId == 70) {
                obj['accountId'] = "";
                obj['tiktok_post_url'] = postUrl;
            } else if (filterId == 71) {
                obj['accountId'] = "";
                obj['feedText'] = handle.split('@').join('');
            } else if (filterId == 72) {
                obj['feedText'] = hashtag.split('#').join('');
            }

            this.setState({ loading: true });
            createFeedAction(obj, [72].includes(filterId) ? 27 : 28, (feedId) => this.setState({ loading: false }, () => {
                if (feedId) {
                    navigation(`/moderation/index/${wallId}`);
                    hideAddfeed();
                }
            }))

        }
    }


    getInfo = (tab) => {
        const { personalAccount } = this.props
        switch (tab) {
            case 'Hashtag':
                return (personalAccount && personalAccount.length > 0) ? 'Initially 20 posts uploaded on accounts will be aggregated after which all the upcoming posts will be aggregated.' : '';
            case 'Handle':
                return 'Initially 32 posts will be aggregated through handle after which all the upcoming posts will be aggregated.';
            case 'Mention':
                return 'You will only get upcoming posts after creating mentions feed.';
            default:
                break;
        }
    }

    needSupportLinks = (filterType) => {
        if (getInitialRoute() === 'widget') {
            switch (filterType) {
                case 'My Handle':
                    return ['https://vimeo.com/715480853', 'https://taggbox.com/support/add-tiktok-videos-to-website/']
                case 'Post Url':
                    return ['https://player.vimeo.com/video/497245578', 'https://taggbox.com/support/add-tiktok-videos-to-website/']
                default:
                    return ['https://vimeo.com/715480853', 'https://taggbox.com/support/add-tiktok-videos-to-website/']
            }
        } else {
            switch (filterType) {
                case 'My Handle':
                    return ['https://vimeo.com/715480853', 'https://taggbox.com/support/add-tiktok-videos-to-website/']
                case 'Post Url':
                    return ['https://player.vimeo.com/video/497245578', 'https://taggbox.com/support/add-tiktok-videos-to-website/']
                default:
                    return ['https://vimeo.com/715480853', 'https://taggbox.com/support/add-tiktok-videos-to-website/']
            }
        }
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        if (type == "addFeed") addUserAccount(networkId, data, (accountId) => this.onAddConnection(accountId, networkId), localStorage.getItem('ownerId'));
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    handleGroupClick = (e) => {
        this.setState({ selectedCategory: e, hashtagSuggestion: [], hashtag: '' })
        if (this.selectRef.current) this.selectRef.current.blur();
    }

    customFormatGroupLabel = (group) => (<div onClick={() => this.handleGroupClick(group)}> {group.label}  </div>);

    render() {
        const { postUrl, manuallyApprove, error, filterType, loading, hashtag, handle, hashtagError, handleError, countries, selectedCountry, category, selectedCategory, hashtagSuggestion } = this.state
        const { feedInfo, connectedAcc, onBack, personalAccount } = this.props
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-body create_feed_wt">
                        <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                            <Tabs defaultActiveKey="Hashtag" mountOnEnter={false} unmountOnExit={false} value={filterType} id="TiktokFeedTab" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3" onSelect={e => this.setState({ filterType: e, filterId: GET_FLITER_ID(e, feedInfo) }, () => this.props.onFilterNameChange(e))}>
                                <Tab eventKey={'Hashtag'} key={'Hashtag'} className="nav-link className= p-0" title={<span>{'Hashtag(#)'}</span>}>
                                    <div className='row'>
                                        {(personalAccount && personalAccount.length) ?
                                            <><div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text">
                                                                <i className="fas fa-location-dot fs-6"></i>
                                                            </span>
                                                        </div>
                                                        <Select
                                                            value={selectedCountry}
                                                            onChange={(e) => this.setState({ selectedCountry: e, hashtagSuggestion: [] })}
                                                            name="country"
                                                            options={countries}
                                                            placeholder="Select Country"
                                                            className="selectpicker selectpicker-lg country-select"
                                                        />

                                                    </div>
                                                </div>
                                            </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">
                                                                    <i className="fas fa-layer-group fs-6"></i>
                                                                </span>
                                                            </div>
                                                            <Select
                                                                name="colors"
                                                                ref={this.selectRef}
                                                                className="selectpicker selectpicker-lg country-select"
                                                                placeholder="Select Hashtag Category"
                                                                formatGroupLabel={this.customFormatGroupLabel}
                                                                options={category}
                                                                // menuIsOpen={true} // This keeps the dropdown open
                                                                onChange={(e) => this.setState({ selectedCategory: e, hashtagSuggestion: [], hashtag: '' })}
                                                                value={selectedCategory}
                                                            />
                                                        </div>
                                                    </div>
                                                </div></> : null}
                                    </div>
                                    <div className="form-group position-relative">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className={`fas fa-hashtag`}></i>
                                                </span>
                                            </div>
                                            <InputField name={"hashtag"} id='tiktok_hashtag' autoComplete={true} className={`autosearch mycheck form-control`} placeholder={`${personalAccount && personalAccount.length ? 'Enter trending hashtag' : `Enter hashtag`}`} value={hashtag} onChangeHandler={(e) => this.onTextChange(e)} />
                                        </div>

                                        {hashtagSuggestion.length ? (
                                            <div className="suggestion">
                                                <ul>
                                                    {hashtagSuggestion.map((e) => (
                                                        <li key={e.hashtagId} onClick={() => this.setState({ selectdeHastag: e, hashtag: e.hashtagName, hashtagSuggestion: [] })}>
                                                            {e.hashtagName}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ) : null}
                                        {hashtagError ? <span id="feedsfield2error" className="errorMessage required">This field is required</span> : null}

                                    </div>

                                    <div className="form-group">
                                        {(personalAccount && personalAccount.length) ? <AccountSelect connectedAcc={personalAccount} onConnectedAccountChange={this.onConnectedPrAccountChange} /> :

                                            <div className="form-group text-center">
                                                <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3" onClick={() => this.onAddAccount(27, 'Business')}>
                                                    <span className="symbol symbol-25 me-3">
                                                        <img src={`${MediaBaseUrl}social-icons/tiktok.svg`} alt="tiktok" />
                                                    </span>
                                                    <span className="text-dark-50 font-weight-bolder font-size-base">Connect TikTok Business</span>
                                                </a>
                                                <div className='mt-2'>Connect your TikTok Business Account for Better Experience</div>
                                            </div>
                                        }
                                    </div>

                                    <div className="hideforBSearch">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_hashtag" />
                                        </div>
                                    </div>


                                </Tab>
                                <Tab eventKey={'Mention'} key={'Mention'} className="nav-link className= p-0" title={<span>{'Mention'}</span>}>
                                    {(connectedAcc && connectedAcc.length > 0) ? <AccountSelect connectedAcc={connectedAcc} onConnectedAccountChange={this.onConnectedAccountChange} /> :
                                        <div className="form-group text-center">
                                            <div className="py-3">
                                                <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3" onClick={() => this.onAddAccount(28, 'Personal')}>
                                                    <span className="symbol symbol-25 me-3">
                                                        <img src={`${MediaBaseUrl}social-icons/tiktok.svg`} alt="tiktok" />
                                                    </span>
                                                    <span className="text-dark-50 font-weight-bolder font-size-base">Connect TikTok Personal</span>
                                                </a>
                                            </div>
                                        </div>
                                    }
                                    <div className="hideforBSearch">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_handle" />
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey={'Handle'} key={'Handle'} className="nav-link className= p-0" title={<span>{'Handle(@)'}</span>}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className={`fas fa-at`}></i>
                                                </span>
                                            </div>
                                            <InputField name={"handle"} id='tiktok_handle' autoComplete={true} className={`autosearch mycheck form-control`} placeholder="Enter user handle" value={handle} onChangeHandler={(e) => this.onTextChange(e)} />
                                        </div>
                                        {handleError ? <span id="feedsfield2error" className="errorMessage required">This field is required</span> : null}
                                    </div>
                                    <div className="hideforBSearch">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_handle" />
                                        </div>
                                    </div>
                                </Tab>

                                <Tab eventKey={'My Handle'} key={'My Handle'} className="nav-link p-0 ms-0 mt-0" title={<span>{'My Handle(@)'}</span>}>
                                    {(connectedAcc && connectedAcc.length > 0) ? <AccountSelect connectedAcc={connectedAcc} onConnectedAccountChange={this.onConnectedAccountChange} /> :
                                        <div className="form-group text-center">
                                            <div className="py-3">
                                                <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3" onClick={() => this.onAddAccount(28, 'Personal')}>
                                                    <span className="symbol symbol-25 me-3">
                                                        <img src={`${MediaBaseUrl}social-icons/tiktok.svg`} alt="tiktok" />
                                                    </span>
                                                    <span className="text-dark-50 font-weight-bolder font-size-base">Connect TikTok Personal</span>
                                                </a>
                                            </div>
                                        </div>
                                    }
                                    <div className="hideforBSearch mt-2">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_account" />
                                        </div>
                                    </div>
                                </Tab>

                                <Tab eventKey={'Post Url'} key={'Post Url'} className="nav-link p-0 ms-0 mt-0" title={<span>{'Post Url'}</span>}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="fas fa-link"></i>
                                                </span>
                                            </div>
                                            <InputField className="form-control" id='tiktok_url' value={postUrl} onChangeHandler={e => this.onPostUrlChange(e.target.value)} placeholder="Enter Tiktok Post Url" />
                                        </div>
                                        {error ? <span id="feedstiktok_post_urlerror" className="errorMessage required">This field is required.</span> : null}
                                    </div>
                                    <div className="hideforBSearch mt-2">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_url" />
                                        </div>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                    {this.getInfo(filterType) ? <InfoSection text={this.getInfo(filterType)} /> : null}
                    <div className="form-actions">
                        <div className="f-between flex-wrap border-top pt-3 mt-4">
                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
                            <SubmitFeedRequest onSubmit={this.onSubmit} onBack={onBack} loading={loading} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        connectedAcc: state.addFeedReducer.connectedAcc,
        personalAccount: state.addFeedReducer.personalAccount,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        FETCH_CONNECTED_ACCOUNTS: (id) => dispatch(getConnectedAccount(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tiktokfeed)